import ruby from './ruby';
import python from './python';
import java from './java';
import php from './php';
import node from './node';
import go from './go';
import dotnet from './dotnet';
import react from './react';
import reactNode from './react-node';

const instructions = {
  ruby: {
    build: 'bundle install',
    run: 'ruby server.rb -o 0.0.0.0',
    entry: 'localhost:4242/checkout.html',
  },
  python: {
    build: 'pip3 install -r requirements.txt',
    run: 'export FLASK_APP=server.py\npython3 -m flask run --port=4242',
    entry: 'localhost:4242/checkout.html',
  },
  php: {
    build: 'composer install',
    run: 'php -S 127.0.0.1:4242 -docroot=public',
    entry: 'localhost:4242/public/checkout.html',
  },
  java: {
    build: 'mvn package',
    run:
      'java -cp target/stripe-card-payment-1.0.0-SNAPSHOT-jar-with-dependencies.jar com.stripe.sample.Server',
    entry: 'localhost:4242/checkout.html',
  },
  node: {
    build: 'npm install',
    run: 'npm start',
    entry: 'localhost:4242/checkout.html',
  },
  go: {
    build: '',
    run: 'go run server.go',
    entry: 'localhost:4242/checkout.html',
  },
  dotnet: {
    build: 'dotnet restore',
    run: 'dotnet run',
    entry: 'localhost:4242/checkout.html',
  },
  html: {
    build: '',
    run: '',
  },
  react: {
    build: 'npm install',
    run: 'npm start',
    entry: 'localhost:3000/checkout',
  },
  swift: {},
  objc: {},
  kotlin: {},
  javaclient: {},
};

const buildFiles = {
  php: {
    files: [{name: 'composer.json', raw: php.build}],
  },
  java: {
    files: [{name: 'pom.xml', raw: java}],
  },
  node: {
    files: [{name: 'package.json', raw: node.build}],
  },
  ruby: {
    files: [{name: 'Gemfile', raw: ruby.build}],
  },
  python: {
    files: [{name: 'requirements.txt', raw: python}],
  },
  go: {
    files: [{name: 'go.mod', raw: go.build}],
  },
  dotnet: {
    files: [{name: 'StripeExample.csproj', raw: dotnet.build}],
  },
  react: {
    files: [
      {name: 'package.json', raw: react.build},
      {name: 'src/index.js', raw: react.indexJs},
      {name: 'public/index.html', raw: react.indexHtml},
    ],
  },
  reactNode: {
    files: [
      {name: 'package.json', raw: reactNode},
      {name: 'src/index.js', raw: react.indexJs},
      {name: 'public/index.html', raw: react.indexHtml},
    ],
  },
  swift: {},
  objc: {},
  kotlin: {},
  javaclient: {},
};

const generateFiles = (client, server) => {
  if (
    client === 'swift' ||
    client === 'objc' ||
    client === 'java' ||
    client === 'kotlin'
  ) {
    return {}; // TODO: Include build files for mobile
  }

  if (client === 'react' && server === 'node') {
    return buildFiles.reactNode;
  } else if (client === 'react') {
    return {files: [...buildFiles.react.files, ...buildFiles[server].files]};
  }

  return buildFiles[server];
};

const nodeReactReadme =
  '1. Build the application\n\n```npm install```\n\n 2. Run the application\n\n```npm start```\n\n3. Go to [localhost:3000/](localhost:3000/)\n';

const readme = (client, server) => {
  let doc = `# Accept a Card Payment\n\nBuild a simple checkout form to collect card details. Included are some basic build and run scripts you can use to start up the application.\n\n## Running the sample\n\n`;
  const serverInstructions = instructions[server];
  const clientInstructions = instructions[client];
  if (client === 'react' && server === 'node') {
    return doc + nodeReactReadme;
  }
  let step = 1;
  if (serverInstructions.build) {
    doc += `${step}. Build the server\n\n\`\`\`\n${serverInstructions.build}\n\`\`\`\n\n`;
    step++;
  }
  if (serverInstructions.run) {
    doc += `${step}. Run the server\n\n\`\`\`\n${serverInstructions.run}\n\`\`\`\n\n`;
    step++;
  }
  if (clientInstructions.build) {
    doc += `${step}. Build the client app\n\n\`\`\`\n${clientInstructions.build}\n\`\`\`\n\n`;
    step++;
  }
  if (clientInstructions.run) {
    doc += `${step}. Run the client app\n\n\`\`\`\n${clientInstructions.run}\n\`\`\`\n\n`;
    step++;
  }
  doc += `${step}. Go to [http://${clientInstructions.entry ||
    serverInstructions.entry}](http://${clientInstructions.entry ||
    serverInstructions.entry})\n`;

  return doc;
};

export default {
  readme,
  buildInstructions: generateFiles,
};
